/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AddressOutput } from './AddressOutput';
import {
    AddressOutputFromJSON,
    AddressOutputFromJSONTyped,
    AddressOutputToJSON,
    AddressOutputToJSONTyped,
} from './AddressOutput';

/**
 * 
 * @export
 * @interface PartnerAddressOutput
 */
export interface PartnerAddressOutput {
    /**
     * 
     * @type {Array<AddressOutput>}
     * @memberof PartnerAddressOutput
     */
    postalAddresses?: Array<AddressOutput>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PartnerAddressOutput
     */
    emailAddresses?: Array<string>;
}

/**
 * Check if a given object implements the PartnerAddressOutput interface.
 */
export function instanceOfPartnerAddressOutput(value: object): value is PartnerAddressOutput {
    return true;
}

export function PartnerAddressOutputFromJSON(json: any): PartnerAddressOutput {
    return PartnerAddressOutputFromJSONTyped(json, false);
}

export function PartnerAddressOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnerAddressOutput {
    if (json == null) {
        return json;
    }
    return {
        
        'postalAddresses': json['postalAddresses'] == null ? undefined : ((json['postalAddresses'] as Array<any>).map(AddressOutputFromJSON)),
        'emailAddresses': json['emailAddresses'] == null ? undefined : json['emailAddresses'],
    };
}

export function PartnerAddressOutputToJSON(json: any): PartnerAddressOutput {
    return PartnerAddressOutputToJSONTyped(json, false);
}

export function PartnerAddressOutputToJSONTyped(value?: PartnerAddressOutput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'postalAddresses': value['postalAddresses'] == null ? undefined : ((value['postalAddresses'] as Array<any>).map(AddressOutputToJSON)),
        'emailAddresses': value['emailAddresses'],
    };
}

